import { atom } from "jotai";

export type lockedSlotAtomValue = {
  slotIds: string[];
  lockTime: number; // timestamp
};

export const LockedSlots_atom = atom<lockedSlotAtomValue | null>(null);
